export default function (state, { id = null, code = null }) {
  state.notifications = state.notifications.filter((n) => n.id !== id && (!n.code || n.code !== code));
}
